/**
 * Axios configuration for Dealer's Decoder API
 * @module DecoderAPI
 *
 * This a public API in the dealerappcenter organization
 * The purpose is to retrieve vehicle's information based on a vehicle's vim ID.
 */

import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_DECODER_URL}/v1`,
});

export default instance;
